module.exports = __webpack_public_path__ + "img/pill.069fe997.png";